var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 98,
    viewBox: "0 0 114 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bot\xC3\xB3n Chat",
    filter: "url(#filter0_d_69_1135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icono Chat"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    cx: 57,
    cy: 51,
    r: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 87C76.8823 87 93 70.8823 93 51C93 31.1178 76.8823 15 57 15C37.1178 15 21 31.1178 21 51C21 70.8823 37.1178 87 57 87Z",
    fill: "#0885C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.792 56.088C82.616 55.2773 82.52 54.4347 82.2533 53.6507C81.1707 50.4453 79.0427 48.0773 76.168 46.3813C72.4027 44.1573 68.3227 43.48 64.0293 44.184C60.1787 44.8133 56.8613 46.4933 54.2427 49.4533C50.6907 53.4693 50.1733 59.1067 53.08 63.5973C55.9707 68.0667 60.3173 70.1093 65.464 70.6587C67.9067 70.92 70.296 70.5253 72.6587 69.9173C72.872 69.864 73.1547 69.864 73.3467 69.96C74.5147 70.5413 75.6667 71.1547 76.8187 71.7627C77.2507 71.992 77.688 72.2213 78.1947 72.4933C78.1467 72.328 78.1307 72.2587 78.1093 72.184C77.6933 70.8933 77.288 69.5973 76.856 68.3067C76.7707 68.0507 76.7813 67.896 77.0213 67.7413C77.3467 67.528 77.6453 67.2773 77.9493 67.0267C80.0987 65.272 81.6827 63.1227 82.4347 60.424C82.6267 59.7307 82.7227 59.0053 82.8613 58.3013C82.8613 57.656 82.8613 57.0107 82.8613 56.36C82.84 56.264 82.8133 56.1787 82.792 56.088ZM62.2533 55.1173C61.08 55.1173 60.1307 54.168 60.1307 52.9947C60.1307 51.8213 61.08 50.872 62.2533 50.872C63.4267 50.872 64.376 51.8213 64.376 52.9947C64.376 54.168 63.4267 55.1173 62.2533 55.1173ZM72.5893 55.1173C71.416 55.1173 70.4667 54.168 70.4667 52.9947C70.4667 51.8213 71.416 50.872 72.5893 50.872C73.7627 50.872 74.712 51.8213 74.712 52.9947C74.712 54.168 73.7627 55.1173 72.5893 55.1173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5147 54.552C51.3093 51.032 53.3627 48.344 56.2427 46.2747C59.6933 43.8 63.6133 42.8347 67.8213 42.92C68.088 42.9253 68.3547 42.92 68.6267 42.92C68.632 42.8613 68.6427 42.8187 68.632 42.7867C68.5413 42.4347 68.4667 42.0773 68.3547 41.736C66.9093 37.1707 63.88 33.944 59.6933 31.8267C54.568 29.2293 49.176 28.8667 43.6827 30.504C39.3627 31.7893 35.8107 34.2213 33.3627 38.072C31.512 40.9787 30.776 44.168 31.304 47.6027C31.816 50.9307 33.384 53.72 35.7893 56.0347C36.648 56.8613 37.6027 57.592 38.536 58.392C37.9547 60.1307 37.352 61.9227 36.7173 63.8213C37.0053 63.672 37.176 63.5867 37.3413 63.5013C39.096 62.568 40.8613 61.6347 42.6107 60.6853C42.9147 60.52 43.176 60.488 43.5173 60.5947C45.6027 61.24 47.7413 61.544 49.9173 61.592C50.232 61.5973 50.552 61.592 50.9147 61.592C50.8453 61.3467 50.7973 61.1813 50.7493 61.016C50.1147 58.8827 50.0187 56.7227 50.5147 54.552ZM56.4933 37.2773C57.9653 37.2773 59.1547 38.4667 59.1547 39.9387C59.1547 41.4107 57.9653 42.6 56.4933 42.6C55.0213 42.6 53.832 41.4107 53.832 39.9387C53.832 38.472 55.0213 37.2773 56.4933 37.2773ZM43.528 42.6C42.056 42.6 40.8667 41.4107 40.8667 39.9387C40.8667 38.4667 42.056 37.2773 43.528 37.2773C45 37.2773 46.1893 38.4667 46.1893 39.9387C46.1893 41.4107 45 42.6 43.528 42.6Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_69_1135",
    x: -1,
    y: 0,
    width: 122,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_69_1135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_69_1135",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.e80e3a169072603370976c785e60c81a.svg";
export { ForwardRef as ReactComponent };